import { memo } from 'react'

import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'

import styles from './CardControls.module.scss'
import { CardControlsArt } from './CardControlsArt/CardControlsArt'
import { CardControlsClipboard } from './CardControlsClipboard/CardControlsClipboard'
import { CardControlsModal } from './CardControlsModal/CardControlsModal'

type Props = {
  controls?: 'left' | 'right'
  disableModal?: boolean
  rec: RecType
  size?: 'sm'
}

const CardControlsInner = ({ controls = 'right', disableModal, rec, size }: Props) => (
  <ul className={cn(styles.container, { controls, size, styles })}>
    <CardControlsArt rec={rec} />
    <CardControlsClipboard rec={rec} />
    {!disableModal && <CardControlsModal rec={rec} />}
  </ul>
)

export const CardControls = memo(CardControlsInner)
